<template>
  <div class="waitingPage">
    <img :src="waiting" class="waiting" />
    <div class="tips">页面正在努力完善中 ...</div>
  </div>
</template>

<script type="text/javascript">
import waiting from "../../assets/img/home/waiting.png";
export default {
  name: "Waiting",
  data() {
    return {
      waiting: waiting,
    };
  },
};
</script>

<style scoped>
.waitingPage {
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}
.waiting {
  margin: 280px auto 0 auto;
  width: 194px;
  height: 169px;
}
.tips {
  margin: 39px auto 0 auto;
  font-size: 26px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Waiting.vue